import React, { useState, useMemo } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import {
  MagnifyingGlassIcon,
  FunnelIcon,
  Squares2X2Icon,
  ListBulletIcon,
  HeartIcon,
  ClockIcon,
  FireIcon,
  SparklesIcon,
  ChevronDownIcon,
  XMarkIcon,
  AdjustmentsHorizontalIcon,
} from '@heroicons/react/24/outline';
import { HeartIcon as HeartSolidIcon } from '@heroicons/react/24/solid';

// Mock data para la galería
const mockItems = [
  { id: 1,  name: 'Equus Dualis #5',         collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 5.png',   currentBid: 42.0, floorPrice: 38.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 5),  category: 'Art',          rarity: 'Legendary', likes: 342, isLiked: false, auctionType: 'English', totalBids: 23 },
  { id: 2,  name: 'Warrior Mythology #16',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology16.jpg', currentBid: 18.5, floorPrice: 15.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 12), category: 'Art',          rarity: 'Rare',      likes: 189, isLiked: true,  auctionType: 'Dutch',   totalBids: 15 },
  { id: 3,  name: 'Equus Dualis #23',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 23.png',  currentBid: 12.5, floorPrice: 10.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 24), category: 'Art',          rarity: 'Epic',      likes: 567, isLiked: false, auctionType: 'English', totalBids: 31 },
  { id: 4,  name: 'Warrior Mythology #44',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology44.jpg', currentBid: 8.2,  floorPrice: 7.0,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 2),  category: 'Art',          rarity: 'Common',    likes: 98,  isLiked: false, auctionType: 'Candle',  totalBids: 8  },
  { id: 5,  name: 'Equus Dualis #10',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 10.png',  currentBid: 5.8,  floorPrice: 4.5,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 8),  category: 'Collectibles', rarity: 'Rare',      likes: 234, isLiked: true,  auctionType: 'Vickrey', totalBids: 19 },
  { id: 6,  name: 'Warrior Mythology #63',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology63.jpg', currentBid: 15.3, floorPrice: 12.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 48), category: 'Art',          rarity: 'Epic',      likes: 445, isLiked: false, auctionType: 'English', totalBids: 27 },
  { id: 7,  name: 'Equus Dualis #27',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 27.png',  currentBid: 3.2,  floorPrice: 2.8,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 6),  category: 'Collectibles', rarity: 'Common',    likes: 156, isLiked: false, auctionType: 'Dutch',   totalBids: 12 },
  { id: 8,  name: 'Warrior Mythology #52',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology52.jpg', currentBid: 6.7,  floorPrice: 5.5,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 18), category: 'Art',          rarity: 'Rare',      likes: 289, isLiked: true,  auctionType: 'English', totalBids: 21 },
  { id: 9,  name: 'Equus Dualis #14',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 14.png',  currentBid: 9.4,  floorPrice: 8.0,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 3),  category: 'Art',          rarity: 'Epic',      likes: 411, isLiked: false, auctionType: 'Candle',  totalBids: 34 },
  { id: 10, name: 'Warrior Mythology #35',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology35.jpg', currentBid: 22.0, floorPrice: 19.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 9),  category: 'Art',          rarity: 'Legendary', likes: 512, isLiked: true,  auctionType: 'English', totalBids: 41 },
  { id: 11, name: 'Equus Dualis #6',         collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 6.png',   currentBid: 7.1,  floorPrice: 6.0,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 15), category: 'Collectibles', rarity: 'Rare',      likes: 178, isLiked: false, auctionType: 'Vickrey', totalBids: 16 },
  { id: 12, name: 'Warrior Mythology #71',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology71.jpg', currentBid: 11.2, floorPrice: 9.5,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 7),  category: 'Art',          rarity: 'Epic',      likes: 337, isLiked: false, auctionType: 'Dutch',   totalBids: 22 },
  { id: 13, name: 'Equus Dualis #30',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 30.png',  currentBid: 55.0, floorPrice: 48.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 36), category: 'Art',          rarity: 'Legendary', likes: 623, isLiked: true,  auctionType: 'English', totalBids: 58 },
  { id: 14, name: 'Warrior Mythology #27',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology27.jpg', currentBid: 4.9,  floorPrice: 4.0,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 4),  category: 'Art',          rarity: 'Common',    likes: 87,  isLiked: false, auctionType: 'Candle',  totalBids: 9  },
  { id: 15, name: 'Equus Dualis #16',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 16.png',  currentBid: 13.7, floorPrice: 11.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 20), category: 'Collectibles', rarity: 'Rare',      likes: 201, isLiked: true,  auctionType: 'English', totalBids: 25 },
  { id: 16, name: 'Warrior Mythology #48',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology48.jpg', currentBid: 9.8,  floorPrice: 8.5,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 11), category: 'Art',          rarity: 'Rare',      likes: 264, isLiked: false, auctionType: 'Vickrey', totalBids: 18 },
  { id: 17, name: 'Equus Dualis #9',         collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 9.png',   currentBid: 6.3,  floorPrice: 5.2,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 13), category: 'Art',          rarity: 'Common',    likes: 143, isLiked: false, auctionType: 'Dutch',   totalBids: 11 },
  { id: 18, name: 'Warrior Mythology #77',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology77.jpg', currentBid: 28.5, floorPrice: 24.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 72), category: 'Art',          rarity: 'Legendary', likes: 734, isLiked: true,  auctionType: 'English', totalBids: 67 },
  { id: 19, name: 'Equus Dualis #20',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 20.png',  currentBid: 17.0, floorPrice: 14.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 16), category: 'Art',          rarity: 'Epic',      likes: 389, isLiked: false, auctionType: 'Candle',  totalBids: 29 },
  { id: 20, name: 'Warrior Mythology #19',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology19.jpg', currentBid: 7.5,  floorPrice: 6.2,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 10), category: 'Collectibles', rarity: 'Rare',      likes: 198, isLiked: false, auctionType: 'English', totalBids: 17 },
  { id: 21, name: 'Equus Dualis #25',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 25.png',  currentBid: 31.0, floorPrice: 27.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 28), category: 'Art',          rarity: 'Legendary', likes: 487, isLiked: true,  auctionType: 'Vickrey', totalBids: 44 },
  { id: 22, name: 'Warrior Mythology #56',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology56.jpg', currentBid: 5.1,  floorPrice: 4.3,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 1),  category: 'Art',          rarity: 'Common',    likes: 112, isLiked: false, auctionType: 'Dutch',   totalBids: 7  },
  { id: 23, name: 'Equus Dualis #3',         collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 3.png',   currentBid: 24.0, floorPrice: 20.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 22), category: 'Art',          rarity: 'Epic',      likes: 356, isLiked: false, auctionType: 'English', totalBids: 32 },
  { id: 24, name: 'Warrior Mythology #38',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology38.jpg', currentBid: 10.6, floorPrice: 9.0,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 14), category: 'Art',          rarity: 'Rare',      likes: 221, isLiked: true,  auctionType: 'Candle',  totalBids: 20 },
  { id: 25, name: 'Equus Dualis #18',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 18.png',  currentBid: 19.5, floorPrice: 16.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 40), category: 'Collectibles', rarity: 'Epic',      likes: 403, isLiked: false, auctionType: 'English', totalBids: 37 },
  { id: 26, name: 'Warrior Mythology #65',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology65.jpg', currentBid: 14.8, floorPrice: 12.5, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 6),  category: 'Art',          rarity: 'Rare',      likes: 276, isLiked: false, auctionType: 'Vickrey', totalBids: 24 },
  { id: 27, name: 'Equus Dualis #22',        collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 22.png',  currentBid: 8.9,  floorPrice: 7.5,  currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 17), category: 'Art',          rarity: 'Common',    likes: 134, isLiked: false, auctionType: 'Dutch',   totalBids: 13 },
  { id: 28, name: 'Warrior Mythology #73',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology73.jpg', currentBid: 36.0, floorPrice: 31.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 60), category: 'Art',          rarity: 'Legendary', likes: 819, isLiked: true,  auctionType: 'English', totalBids: 73 },
  { id: 29, name: 'Equus Dualis #8',         collection: 'Equus Dualis II',    image: '/Equus Dualis/Equus Dualis II ) 8.png',   currentBid: 16.2, floorPrice: 13.5, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 19), category: 'Art',          rarity: 'Epic',      likes: 318, isLiked: false, auctionType: 'Candle',  totalBids: 28 },
  { id: 30, name: 'Warrior Mythology #24',   collection: 'Warrior Mythology',  image: '/warrior mythology/warrior mythology24.jpg', currentBid: 11.9, floorPrice: 10.0, currency: 'ETH', endTime: new Date(Date.now() + 3600000 * 23), category: 'Collectibles', rarity: 'Rare',      likes: 247, isLiked: false, auctionType: 'English', totalBids: 22 },
];

const categories = ['Todos', 'Art', 'Collectibles', 'Metaverse', 'Gaming', 'Music', 'Photography'];
const rarities = ['Todas', 'Common', 'Rare', 'Epic', 'Legendary'];
const auctionTypes = ['Todos', 'English', 'Dutch', 'Vickrey', 'Candle'];
const sortOptions = [
  { value: 'ending_soon', label: 'Termina Pronto' },
  { value: 'price_low', label: 'Precio: Menor a Mayor' },
  { value: 'price_high', label: 'Precio: Mayor a Menor' },
  { value: 'most_bids', label: 'Más Pujas' },
  { value: 'most_liked', label: 'Más Populares' },
  { value: 'recently_listed', label: 'Recientes' },
];

const ExplorePage: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Todos');
  const [selectedRarity, setSelectedRarity] = useState('Todas');
  const [selectedAuctionType, setSelectedAuctionType] = useState('Todos');
  const [sortBy, setSortBy] = useState('ending_soon');
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');
  const [showFilters, setShowFilters] = useState(false);
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 10000]);
  const [items, setItems] = useState(mockItems);

  // Filtrar items
  const filteredItems = useMemo(() => {
    let result = [...items];

    // Búsqueda
    if (searchQuery) {
      result = result.filter(item =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        item.collection.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Categoría
    if (selectedCategory !== 'Todos') {
      result = result.filter(item => item.category === selectedCategory);
    }

    // Rareza
    if (selectedRarity !== 'Todas') {
      result = result.filter(item => item.rarity === selectedRarity);
    }

    // Tipo de subasta
    if (selectedAuctionType !== 'Todos') {
      result = result.filter(item => item.auctionType === selectedAuctionType);
    }

    // Rango de precio
    result = result.filter(item =>
      item.currentBid >= priceRange[0] && item.currentBid <= priceRange[1]
    );

    // Ordenar
    switch (sortBy) {
      case 'ending_soon':
        result.sort((a, b) => a.endTime.getTime() - b.endTime.getTime());
        break;
      case 'price_low':
        result.sort((a, b) => a.currentBid - b.currentBid);
        break;
      case 'price_high':
        result.sort((a, b) => b.currentBid - a.currentBid);
        break;
      case 'most_bids':
        result.sort((a, b) => b.totalBids - a.totalBids);
        break;
      case 'most_liked':
        result.sort((a, b) => b.likes - a.likes);
        break;
    }

    return result;
  }, [items, searchQuery, selectedCategory, selectedRarity, selectedAuctionType, sortBy, priceRange]);

  const toggleLike = (id: number) => {
    setItems(items.map(item =>
      item.id === id
        ? { ...item, isLiked: !item.isLiked, likes: item.isLiked ? item.likes - 1 : item.likes + 1 }
        : item
    ));
  };

  const formatTimeRemaining = (endTime: Date) => {
    const now = new Date();
    const diff = endTime.getTime() - now.getTime();

    if (diff <= 0) return 'Finalizada';

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    if (hours >= 24) {
      const days = Math.floor(hours / 24);
      return `${days}d ${hours % 24}h`;
    }
    return `${hours}h ${minutes}m`;
  };

  const getRarityColor = (rarity: string) => {
    switch (rarity) {
      case 'Legendary': return 'text-yellow-400 bg-yellow-400/10';
      case 'Epic': return 'text-purple-400 bg-purple-400/10';
      case 'Rare': return 'text-blue-400 bg-blue-400/10';
      default: return 'text-gray-400 bg-gray-400/10';
    }
  };

  const getAuctionTypeIcon = (type: string) => {
    switch (type) {
      case 'English': return <FireIcon className="w-4 h-4" />;
      case 'Dutch': return <ChevronDownIcon className="w-4 h-4" />;
      case 'Vickrey': return <SparklesIcon className="w-4 h-4" />;
      case 'Candle': return <ClockIcon className="w-4 h-4" />;
      default: return null;
    }
  };

  return (
    <div className="min-h-screen bg-dark-950 pt-20">
      {/* Hero Section */}
      <section className="relative py-12 bg-gradient-to-b from-dark-900 to-dark-950">
        <div className="absolute inset-0 bg-[url('/grid-pattern.svg')] opacity-5" />
        <div className="container mx-auto px-4 relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Explorar <span className="gradient-text">Subastas</span>
            </h1>
            <p className="text-xl text-gray-400 mb-8">
              Descubre NFTs únicos y participa en subastas descentralizadas
            </p>

            {/* Barra de búsqueda */}
            <div className="relative max-w-2xl mx-auto">
              <MagnifyingGlassIcon className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 text-gray-400" />
              <input
                type="text"
                placeholder="Buscar por nombre, colección o artista..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full pl-12 pr-4 py-4 bg-dark-800 border border-dark-700 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-primary-500 transition-colors"
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  className="absolute right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-dark-700 rounded"
                >
                  <XMarkIcon className="w-5 h-5 text-gray-400" />
                </button>
              )}
            </div>
          </motion.div>
        </div>
      </section>

      {/* Filtros y Resultados */}
      <section className="py-8">
        <div className="container mx-auto px-4">
          {/* Barra de filtros */}
          <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
            {/* Categorías */}
            <div className="flex flex-wrap gap-2">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    selectedCategory === category
                      ? 'bg-primary-500 text-white'
                      : 'bg-dark-800 text-gray-400 hover:text-white hover:bg-dark-700'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>

            {/* Controles */}
            <div className="flex items-center gap-3">
              {/* Botón filtros avanzados */}
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`flex items-center gap-2 px-4 py-2 rounded-lg text-sm transition-colors ${
                  showFilters
                    ? 'bg-primary-500 text-white'
                    : 'bg-dark-800 text-gray-400 hover:text-white'
                }`}
              >
                <AdjustmentsHorizontalIcon className="w-5 h-5" />
                Filtros
              </button>

              {/* Selector de orden */}
              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
                className="px-4 py-2 bg-dark-800 border border-dark-700 rounded-lg text-sm text-white focus:outline-none focus:border-primary-500"
              >
                {sortOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>

              {/* Vista grid/list */}
              <div className="flex bg-dark-800 rounded-lg p-1">
                <button
                  onClick={() => setViewMode('grid')}
                  className={`p-2 rounded ${viewMode === 'grid' ? 'bg-dark-700 text-white' : 'text-gray-400'}`}
                >
                  <Squares2X2Icon className="w-5 h-5" />
                </button>
                <button
                  onClick={() => setViewMode('list')}
                  className={`p-2 rounded ${viewMode === 'list' ? 'bg-dark-700 text-white' : 'text-gray-400'}`}
                >
                  <ListBulletIcon className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>

          {/* Panel de filtros avanzados */}
          {showFilters && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="bg-dark-800/50 rounded-xl p-6 mb-8 border border-dark-700"
            >
              <div className="grid md:grid-cols-4 gap-6">
                {/* Rareza */}
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Rareza</label>
                  <select
                    value={selectedRarity}
                    onChange={(e) => setSelectedRarity(e.target.value)}
                    className="w-full px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg text-white focus:outline-none focus:border-primary-500"
                  >
                    {rarities.map((rarity) => (
                      <option key={rarity} value={rarity}>{rarity}</option>
                    ))}
                  </select>
                </div>

                {/* Tipo de subasta */}
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Tipo de Subasta</label>
                  <select
                    value={selectedAuctionType}
                    onChange={(e) => setSelectedAuctionType(e.target.value)}
                    className="w-full px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg text-white focus:outline-none focus:border-primary-500"
                  >
                    {auctionTypes.map((type) => (
                      <option key={type} value={type}>{type}</option>
                    ))}
                  </select>
                </div>

                {/* Precio mínimo */}
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Precio Mínimo (ETH)</label>
                  <input
                    type="number"
                    value={priceRange[0]}
                    onChange={(e) => setPriceRange([Number(e.target.value), priceRange[1]])}
                    className="w-full px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg text-white focus:outline-none focus:border-primary-500"
                    min="0"
                  />
                </div>

                {/* Precio máximo */}
                <div>
                  <label className="block text-sm text-gray-400 mb-2">Precio Máximo (ETH)</label>
                  <input
                    type="number"
                    value={priceRange[1]}
                    onChange={(e) => setPriceRange([priceRange[0], Number(e.target.value)])}
                    className="w-full px-4 py-2 bg-dark-700 border border-dark-600 rounded-lg text-white focus:outline-none focus:border-primary-500"
                    min="0"
                  />
                </div>
              </div>

              {/* Botón limpiar filtros */}
              <div className="mt-4 flex justify-end">
                <button
                  onClick={() => {
                    setSelectedCategory('Todos');
                    setSelectedRarity('Todas');
                    setSelectedAuctionType('Todos');
                    setPriceRange([0, 10000]);
                    setSearchQuery('');
                  }}
                  className="text-sm text-primary-400 hover:text-primary-300"
                >
                  Limpiar filtros
                </button>
              </div>
            </motion.div>
          )}

          {/* Contador de resultados */}
          <div className="mb-6">
            <p className="text-gray-400">
              <span className="text-white font-semibold">{filteredItems.length}</span> items encontrados
            </p>
          </div>

          {/* Grid de items */}
          <div className={viewMode === 'grid'
            ? 'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6'
            : 'space-y-4'
          }>
            {filteredItems.map((item, idx) => (
              <motion.div
                key={item.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.05 }}
                className={viewMode === 'grid'
                  ? 'bg-dark-800/50 rounded-xl border border-dark-700 overflow-hidden hover:border-primary-500/50 transition-all duration-300 group'
                  : 'bg-dark-800/50 rounded-xl border border-dark-700 overflow-hidden hover:border-primary-500/50 transition-all duration-300 flex'
                }
              >
                {/* Imagen */}
                <Link
                  to={`/auction/${item.id}`}
                  className={viewMode === 'grid' ? 'block' : 'w-48 flex-shrink-0'}
                >
                  <div className="relative aspect-square overflow-hidden">
                    <img
                      src={item.image}
                      alt={item.name}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                    />
                    {/* Overlay con tiempo */}
                    <div className="absolute top-3 left-3 flex items-center gap-1 px-2 py-1 bg-dark-900/80 backdrop-blur-sm rounded-lg text-xs text-white">
                      <ClockIcon className="w-3.5 h-3.5" />
                      {formatTimeRemaining(item.endTime)}
                    </div>
                    {/* Tipo de subasta */}
                    <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-primary-500/80 backdrop-blur-sm rounded-lg text-xs text-white">
                      {getAuctionTypeIcon(item.auctionType)}
                      {item.auctionType}
                    </div>
                    {/* Botón like */}
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        toggleLike(item.id);
                      }}
                      className="absolute bottom-3 right-3 p-2 bg-dark-900/80 backdrop-blur-sm rounded-full hover:bg-dark-800 transition-colors"
                    >
                      {item.isLiked ? (
                        <HeartSolidIcon className="w-5 h-5 text-red-500" />
                      ) : (
                        <HeartIcon className="w-5 h-5 text-white" />
                      )}
                    </button>
                  </div>
                </Link>

                {/* Info */}
                <div className={viewMode === 'grid' ? 'p-4' : 'p-4 flex-1 flex flex-col justify-between'}>
                  <div>
                    <div className="flex items-center justify-between mb-1">
                      <span className="text-xs text-gray-500">{item.collection}</span>
                      <span className={`text-xs px-2 py-0.5 rounded ${getRarityColor(item.rarity)}`}>
                        {item.rarity}
                      </span>
                    </div>
                    <Link to={`/auction/${item.id}`}>
                      <h3 className="text-white font-semibold hover:text-primary-400 transition-colors">
                        {item.name}
                      </h3>
                    </Link>
                  </div>

                  <div className="mt-3 pt-3 border-t border-dark-700">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="text-xs text-gray-500">Puja actual</p>
                        <p className="text-white font-bold">{item.currentBid} {item.currency}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-xs text-gray-500">Floor</p>
                        <p className="text-gray-400">{item.floorPrice} {item.currency}</p>
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-2 text-xs text-gray-500">
                      <span>{item.totalBids} pujas</span>
                      <span className="flex items-center gap-1">
                        <HeartIcon className="w-3.5 h-3.5" />
                        {item.likes}
                      </span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          {/* Empty state */}
          {filteredItems.length === 0 && (
            <div className="text-center py-16">
              <MagnifyingGlassIcon className="w-16 h-16 text-gray-600 mx-auto mb-4" />
              <h3 className="text-xl font-semibold text-white mb-2">No se encontraron resultados</h3>
              <p className="text-gray-400 mb-6">Intenta ajustar los filtros o buscar con otros términos</p>
              <button
                onClick={() => {
                  setSelectedCategory('Todos');
                  setSelectedRarity('Todas');
                  setSelectedAuctionType('Todos');
                  setPriceRange([0, 10000]);
                  setSearchQuery('');
                }}
                className="px-6 py-2 bg-primary-500 hover:bg-primary-600 text-white rounded-lg transition-colors"
              >
                Limpiar filtros
              </button>
            </div>
          )}

          {/* Load more */}
          {filteredItems.length > 0 && (
            <div className="text-center mt-12">
              <button className="px-8 py-3 bg-dark-800 hover:bg-dark-700 text-white rounded-xl transition-colors">
                Cargar más items
              </button>
            </div>
          )}
        </div>
      </section>

      {/* Stats rápidas */}
      <section className="py-12 bg-dark-900/30">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <p className="text-3xl font-bold text-white">12,500+</p>
              <p className="text-gray-400 text-sm">NFTs Listados</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-primary-400">500+</p>
              <p className="text-gray-400 text-sm">Colecciones</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-white">$25M+</p>
              <p className="text-gray-400 text-sm">Volumen Total</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-green-400">8,000+</p>
              <p className="text-gray-400 text-sm">Usuarios Activos</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ExplorePage;
